const axios = require('axios')
const { ADDRESS_LIST_URL, ADD_ADDRESS_URL, DELETE_ADDRESS_URL, UPDATE_ADDRESS_URL } = require('./url')
const Header = require('./auth')
/* 获取地址列表 */
function getAddressList (data) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.get(`${ADDRESS_LIST_URL}?pages=${data.pages}&limit=${data.limit}`)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 新增地址 */
function addAddress (data) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.post(`${ADD_ADDRESS_URL}`, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 删除地址 */
function deleteAddress (data) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.post(`${DELETE_ADDRESS_URL}?id=${data.id}`)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 编辑地址 */
function updateAddress (data) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.post(`${UPDATE_ADDRESS_URL}`, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

module.exports = {
  getAddressList,
  addAddress,
  deleteAddress,
  updateAddress
}
